import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

export const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    const response = await api.get('/users');

    if (!response?.ok) {
      setLoading(false);
      return;
    }

    setUsers(response.data.data || []);
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return { data: users, loading, refetch: fetchUsers };
};
